module.exports = __webpack_public_path__ + "static/img/promotion_empty.c373a2e1.png";